import React, { useId, useState } from 'react';
import Spinner from '../../Global/Spinner/Spinner';
import { countries } from '../../../countries.util';
import axios from 'axios';
import { Script } from 'gatsby';

import './index.scss';

const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTHA_PUBLIC_KEY;

function getRecaptchaToken(siteKey) {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha?.ready) {
      reject(new Error('reCAPTCHA not loaded'));
      return;
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(siteKey, { action: 'submit' });
        resolve(token);
      } catch (err) {
        reject(err);
      }
    });
  });
}

const HubspotForm = ({
  formId,
  portalId,
  privacyPolicyMessage,
  thankYouMessage,
  submitButtonLabel = 'Join Us',
  consent,
  formField = [],
}) => {
  const uniqueId = useId();
  const [status, setStatus] = useState({
    loading: false,
    sent: false,
    error: false,
  });

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setStatus((prev) => ({ ...prev, loading: true }));

    const formData = new FormData(e.target);
    const fields = Object.fromEntries(formData.entries());

    try {
      const token = await getRecaptchaToken(RECAPTCHA_SITE_KEY);
      if (!token) {
        throw new Error('Recaptcha token not generated');
      }

      const response = await axios.post('/api/hubspot-form-submit', {
        portalId,
        formId,
        fields,
        consentId: consent,
        recaptchaToken: token,
      });

      if (response.status !== 200) {
        throw new Error('Error on sending form to hubspot');
      }

      setStatus((prev) => ({ ...prev, sent: true, error: false }));
    } catch (error) {
      console.error(error);
      setStatus((prev) => ({ ...prev, sent: false, error: true }));
    }

    setStatus((prev) => ({ ...prev, loading: false }));
  };

  const message = thankYouMessage || 'Thank you for your support';

  return (
    <div className="ui-form-hubspot">
      {!status.sent && (
        <form onSubmit={handleOnSubmit}>
          {formField.map((field) => {
            if (field.name === 'country_multioption') {
              return (
                <select
                  className="ui-select"
                  name="country_multioption"
                  placeholder="Country"
                  onChange={() => {
                    document.querySelector('.ui-select')?.classList.add('selected');
                  }}
                >
                  <option className="placeholder">Country</option>
                  {countries
                    .sort((a, b) => a.name.common.localeCompare(b.name.common))
                    .map((c) => (
                      <option key={c.name.common} value={c.name.common}>
                        {c.name.common}
                      </option>
                    ))}
                </select>
              );
            }

            if (field.typeForm === 'textarea') {
              return (
                <textarea name={field.name} type={field.typeForm} placeholder={field.label} required={field.required} />
              );
            }

            return (
              <input name={field.name} type={field.typeForm} placeholder={field.label} required={field.required} />
            );
          })}

          <button className="submit" type="submit">
            {status.loading ? <Spinner /> : submitButtonLabel}
          </button>

          <div className="consent">
            <input type="checkbox" name="consent" id={`consent-${uniqueId}`} value={consent} />
            <label htmlFor={`consent-${uniqueId}`}>
              <div dangerouslySetInnerHTML={{ __html: privacyPolicyMessage }} />
            </label>
          </div>
        </form>
      )}

      {status.sent && <div className="sent" dangerouslySetInnerHTML={{ __html: message }} />}
      {status.error && <p className="error">An error occurred while completing the form. Please try again.</p>}

      <Script src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`} strategy="post-hydrate" />
    </div>
  );
};

export default HubspotForm;
